import { makeAutoObservable } from 'mobx'
import { type RootStore } from 'stores/RootStore'

type DrawerType = 'plagiarism' | 'seo' | 'review_submission' | 'blog_metadata'
export class RightRailPanelStore {
  rootStore: RootStore

  private _openDrawer: DrawerType | null = null
  private _animated: boolean = true

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  get shown() {
    return this._openDrawer !== null
  }

  get openedDrawer() {
    return this._openDrawer
  }

  get animated() {
    return this._animated
  }

  show(drawer: DrawerType) {
    this._animated = true
    this._openDrawer = drawer
  }

  hide() {
    this._openDrawer = null
  }

  hideImmediately() {
    this._animated = false
    this._openDrawer = null
  }
}
